import { tenantActionTypes } from './tenant.types';

const initialState = {
  error: null
};

const tenantReducer = (state = initialState, action) => {
  switch (action.type) {
    case tenantActionTypes.SET_TENANT_ERROR:
      return {
        ...state,
        error: action.payload
      };
    case tenantActionTypes.CLEAR_TENANT_ERROR:
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};

export default tenantReducer;
